module.exports = __webpack_public_path__ + "img/eu-banner.55a7d592.png";